import { render, staticRenderFns } from "./RatingStatistics.vue?vue&type=template&id=1932620f&scoped=true&"
import script from "./RatingStatistics.vue?vue&type=script&lang=js&"
export * from "./RatingStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RatingStatistics.vue?vue&type=style&index=0&id=1932620f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1932620f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
